export default __webpack_public_path__ + "static/media/decline.01787342.svg";